import { memo } from 'react';

import { PrivatePageSeoTitle } from '~/components/v2/components/shared/seo/PrivatePageSeoTitle';
import { usePrivateWorkspaceAgentAssetListContext } from '~/components/v2/components/workspace/workspace-agent-asset-list/PrivateWorkspaceAgentAssetListProvider';
import { WORKSPACE_AGENT_ASSET_LIST_LABEL } from '~/components/v2/components/workspace/workspace-agent-asset-list/workspaceAgentAssetListConstants';

export const PrivateWorkspaceAgentAssetListSeoTitle = memo(() => {
  const { sessionTitle } = usePrivateWorkspaceAgentAssetListContext();

  return <PrivatePageSeoTitle title={sessionTitle ?? WORKSPACE_AGENT_ASSET_LIST_LABEL} />;
});

PrivateWorkspaceAgentAssetListSeoTitle.displayName = 'PrivateWorkspaceAgentAssetListSeoTitle';
